export enum ErrorCodeChannelType {
  GPP = 'GPP',
  HOST = 'HOST',
  MOP = 'MOP',
  NONE = ''
}
